import { useLingui } from "@lingui/react";
import { formatNumber } from "@mobility-item-page/utilities";
import { useAppConfig } from "../../../context/AppConfigProviderContext.tsx";
import FieldValuePair from "../FieldValuePair.tsx";

export const VolumeLitre = ({ volume }: { volume?: number }) => {
  const { locale } = useAppConfig();
  const { i18n } = useLingui();

  if (volume == null) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.engine.volume",
    message: "Engine volume",
    comment: "Field for 'engine volume' in ad specification",
  });
  const value = i18n.t({
    id: "itemPageLayout.common.litre.postfix",
    message: "{litre} L",
    comment: "Litre postfix in ad specification",
    values: {
      litre: formatNumber(volume, locale),
    },
  });

  return <FieldValuePair field={field} value={value} />;
};
